import { useQuery } from '@tanstack/react-query';

import { getCountries } from '../services/api/country';

export function useCountry() {
  return useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const data = await getCountries();
      return data;
    },
  });
}
